import {XHTTP} from '@/shared/xhttp';
import {DateHelper} from "@/shared/utils";
import {LongueursVente} from "@/models/LongueursVente";

export class PrixClient {

	private _id: number;
	private _longueursVente: LongueursVente;
	private _montant: number;
	private _montantDivers: number;
	private _montantNonLivre: number;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get longueursVente(): LongueursVente {
		return this._longueursVente;
	}

	public get montant(): number {
		return this._montant;
	}

	public get montantDivers(): number {
		return this._montantDivers;
	}

	public get montantNonLivre(): number {
		return this._montantNonLivre;
	}

	/////////////
	// Setters //
	/////////////

	public set longueursVente(value: LongueursVente) {
		this._longueursVente = value;
	}

	public set montant(value: number) {
		this._montant = value;
	}

	public set montantDivers(value: number) {
		this._montantDivers = value;
	}

	public set montantNonLivre(value: number) {
		this._montantNonLivre = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id            : this._id,
			longueursVente : this._longueursVente ? this._longueursVente.id : null,
			montant       : this._montant,
			montantDivers       : this._montantDivers,
			montantNonLivre       : this._montantNonLivre,
		};
	}

	public fromJSON(data: any): this {
		this._id           = data.id
		this._longueursVente  = data.longueursVente ? (new LongueursVente()).fromJSON(data.longueursVente) : null;
		this._montant        = data.montant;
		this._montantDivers        = data.montantDivers;
		this._montantNonLivre        = data.montantNonLivre;
		return this;
	}
}
